import Vue from 'vue'
import Vuex from 'vuex'
import route from './modules/route'
import search from './modules/search'
import jst from './modules/jst'

import genFeaturesList from './genFeaturesList'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    route,
    search,
    jst: jst,
    tereny: genFeaturesList({ url: "/oferty_pub/oferty.geojson" }),
    hale: genFeaturesList({ url: "/hale_pub/hale.geojson" }),
    biura: genFeaturesList({ url: "/biura_pub/biura.geojson" }),
    inwestorzy: genFeaturesList({ url: "/oferty_pub/oferty.geojson?zainwest=true" }),
  },
  strict: debug,
})
